import { render, staticRenderFns } from "./manager_setting.vue?vue&type=template&id=a4a99f30&scoped=true&"
import script from "./manager_setting.vue?vue&type=script&lang=js&"
export * from "./manager_setting.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a4a99f30",
  null
  
)

export default component.exports